import React, { useState } from "react";
import { equals } from "ramda";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { Language } from "@mui/icons-material";

import { languageOptions } from "../model/constants";

type LanguageSelectorProps = {
  value: (typeof languageOptions)[number]["value"];
  onChange: (value: typeof this.value) => void;
};

export const LanguageSelector: React.FC<LanguageSelectorProps> = (props) => {
  const { value, onChange } = props;

  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  const handleChange = (newValue: string) => {
    onChange(newValue);
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElement(null);
  };

  return (
    <>
      <IconButton onClick={handleOpenMenu}>
        <Language />
      </IconButton>
      <Menu
        anchorEl={anchorElement}
        open={Boolean(anchorElement)}
        onClose={handleCloseMenu}
      >
        {languageOptions.map((languageOption) => (
          <MenuItem
            key={languageOption.value}
            selected={equals(languageOption.value, value)}
            onClick={() => handleChange(languageOption.value)}
            sx={{
              "&.Mui-selected": {
                color: "primary.light",
              },
              "&:hover:not(.Mui-selected)": {
                textDecoration: "none",
                backgroundColor: "primary.main",
                color: "primary.contrastText",
              },
            }}
          >
            <ListItemIcon>
              <img
                loading="lazy"
                width="20"
                srcSet={`https://flagcdn.com/w40/${languageOption.value}.png 2x`}
                src={`https://flagcdn.com/w20/${languageOption.value}.png`}
                alt=""
              />
            </ListItemIcon>
            <ListItemText>{languageOption.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
